export const STATUS_TYPES = {
    INFACE_SUCCESS: 1,
    INFACE_FAIL: 0
}

export default {
    STATUS_TYPES
}